import { isNaN } from '@seiue/util'
import { THEME_COLOR } from 'packages/theme'

/**
 * 获取本地存储的需要解析的值
 *
 * @param key - 本地存储的key
 * @returns 本地存储的值
 */
export const getParseLocalValue = (key: string) => {
  const localeValue = localStorage.getItem(key)

  return localeValue && localeValue !== 'undefined'
    ? JSON.parse(localeValue)
    : undefined
}

/**
 * 获取本地存储的数字
 *
 * @param key - 本地存储的key
 * @returns number
 */
export const getNumberLocalValue = (key: string) => {
  const localeValue = localStorage.getItem(key)

  return localeValue &&
    localeValue !== 'undefined' &&
    !isNaN(Number(localeValue))
    ? Number(localeValue)
    : undefined
}

/**
 * 获取本地存储的字符串
 *
 * @param key - 本地存储的key
 * @returns string
 */
export const getThemeLocalValue = (key: string) => {
  const localeValue = localStorage.getItem(key)

  return localeValue && localeValue !== 'undefined'
    ? localeValue.replace(/"/g, '')
    : THEME_COLOR
}

/**
 * 获取本地存储的布尔
 *
 * @param key - 本地存储的key
 * @returns boolean
 */
export const getBooleanLocalValue = (key: string) => {
  const localeValue = localStorage.getItem(key)

  return localeValue?.trim() ? localeValue === 'true' : false
}
